<template>
  <div class="callCenter-container">
    <div class="pc d-none d-lg-block">
      <div class="container" data-aos="fade-left" :data-aos-duration="1 * 1000">
        <div class="content-left">
          <p class="title">IVVR - 5G VOLTE 呼叫中心</p>
          <p class="subtitle">
            为用户呼叫中心提供视频化服务升级方案，支持Volte视频呼<br />入对接人工视频坐席、AI视频坐席、视频IVR进行业务办理。<br />
            可实现服务端截图，截流对接人脸识别、声纹检测、微表<br />情、录音录像、多方会议、屏幕共享。
          </p>
          <p class="btn-text" @click="open">了解更多 →</p>
        </div>
        <div class="content-right">
          <img src="https://zealcomm-site-assets.zealcomm.cn/new-product/call-center.png" alt="" />
        </div>
      </div>
    </div>
    <div class="d-lg-none mobile">
      <div class="container" data-aos="fade-left" :data-aos-duration="1 * 1000">
        <div class="top">
          <p class="title">IVVR - 5G VOLTE 呼叫中心</p>
          <p class="subtitle">
            为用户呼叫中心提供视频化服务升级方案，支持Volte视频呼入对接人工视频坐席、AI视频坐席、视频IVR进行业务办理。<br />
            可实现服务端截图，截流对接人脸识别、声纹检测、微表情、录音录像、多方会议、屏幕共享。
          </p>
          <p class="btn-text" @click="open">了解更多 →</p>
        </div>
        <div class="bottom">
          <img src="~assets/img/solution/callCenter-mobile.png" alt="" />
        </div>
      </div>
    </div>
    <Form v-model="show" />
  </div>
</template>

<script>
  import Form from "@/components/Form/index.vue";
  export default {
    data() {
      return {
        show: false,
      };
    },
    components: {
      Form,
    },
    methods: {
      open() {
        if (typeof this.customBtnClick === "function") {
          this.customBtnClick.call();
        } else {
          this.show = true;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .callCenter-container {
    background-color: #f5f5f7;
    .pc {
      .container {
        display: flex;
        justify-content: space-between;
        padding: 85px 0 88px;
        .content-left {
          flex: 1;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #363636;
          margin-top: 29px;
          .title {
            font-size: 30px;
            font-weight: 500;
          }
          .subtitle {
            text-align: left;
            margin-top: 32px;
            font-size: 18px;
            font-weight: 400;
          }
          .btn-text {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #08c6ad;
            cursor: pointer;
            margin-top: 45px;
          }
        }

        .content-right {
          flex: 1;
          margin-left: 153px;
          img {
            width: 502px;
            height: 337px;
          }
        }
      }
    }

    .mobile {
      .container {
        padding: 32px 0 32px;
        .top {
          font-family: PingFangSC-Medium, PingFang SC;
          color: #363636;
          margin-left: 20px;
          .title {
            font-size: 18px;
            font-weight: 500;
          }
          .subtitle {
            text-align: left;
            font-size: 13px;
            font-weight: 400;
            padding: 18px 41px 0 0;
          }
          .btn-text {
            width: 102px;
            height: 24px;
            border-radius: 3px;
            border: 1px solid #0ab49e;
            margin-top: 16px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #08c6ad;
            text-align: center;
          }
        }
        .bottom {
          margin: 30px 17px 0 20px;
          img {
            width: 338px;
            height: 225px;
          }
        }
      }
    }
  }
</style>
